export default "__VITE_ASSET__e7643f6f__"